import { ReactElement, useState, useEffect } from 'react'
import { CardWrapper, CardHeader } from '../../../components'
import Button from 'react-bootstrap/Button'
import {
  JumpToQuestionsWrapper,
  JumpQuestionsList,
  Tracker,
  StatusMarker,
  StatusMarkerWrapper
} from './subcomponents'
import strings from '../../../locale/en'
import { Question } from '../../../redux/test/type'
import { useSelector, shallowEqual } from 'react-redux'
import { RootState } from '../../../redux/store'
import { colors } from '../../../const/theme'
import { Small } from '../../../typography'
import { convertHMS } from '../../../helpers/formatTime'
import determineButtonVariant from './helpers'

interface JumpToQuestionsProps {
  quesionList: Array<Question>
  question: Question
  //eslint-disable-next-line no-unused-vars
  onClickHandler: (id?: string) => void
  isResults?: boolean
}

const JumpToQuestions = ({
  quesionList,
  question,
  onClickHandler,
  isResults
}: JumpToQuestionsProps): ReactElement => {
  const { duration = 0 } = useSelector(
    (state: RootState) => ({
      duration: state.test?.testPaperDetails?.testPaper?.duration
    }),
    shallowEqual
  )
  const [timer, setTimer] = useState(duration * 60)
  const selectedCount = quesionList.filter((qtn) => !!qtn.answer).length

  const {
    test: { jumpToQuestion, timeRemaining, completed }
  } = strings

  useEffect(() => {
    timer > 0 && setTimeout(() => setTimer(timer - 1), 1000)
  }, [timer])

  return (
    <JumpToQuestionsWrapper>
      <CardWrapper>
        <CardHeader>{jumpToQuestion}</CardHeader>
        {!isResults && (
          <StatusMarkerWrapper>
            <div>
              <StatusMarker color={colors?.green} />
              <Small color={colors?.gray}> {strings.test.completed} </Small>
            </div>
            <div>
              <StatusMarker color={colors?.amber} />
              <Small color={colors?.gray}> {strings.test.marked} </Small>
            </div>
            <div>
              <StatusMarker color={colors?.gray} />
              <Small color={colors?.gray}> {strings.test.read} </Small>
            </div>
            <div>
              <StatusMarker color={colors?.lightGrey} />
              <Small color={colors?.gray}> {strings.test.unRead} </Small>
            </div>
          </StatusMarkerWrapper>
        )}
        <JumpQuestionsList>
          {quesionList.map((qtn, index) => (
            <Button
              variant={determineButtonVariant(qtn)}
              key={`jump-question-${index}`}
              active={qtn?.id === question?.id}
              onClick={() => onClickHandler(qtn?.id)}
            >
              {index + 1}
            </Button>
          ))}
        </JumpQuestionsList>
      </CardWrapper>
      {!isResults && (
        <>
          <Tracker title={convertHMS(timer)} subTitle={timeRemaining} />
          <Tracker
            title={`${selectedCount} out of ${quesionList.length}`}
            subTitle={completed}
          />
        </>
      )}
    </JumpToQuestionsWrapper>
  )
}

export default JumpToQuestions
